import { getUsersIsFetching } from '@selectors/users';
import dayjs from 'dayjs';
import ActionButton from 'lib/src/components/button/ActionButton';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import LinkButton from '@components/button/LinkButton';
import Table from 'lib/src/components/table/Table';
import { convertArrToObj } from 'lib/src/utils/generic';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Submission } from 'src/types/shared/Assessments';
import DeleteUserApplicationModal from './DeleteUserApplicationModal';

const UsersTable: React.FC<ApplicationTableProps> = ({ applications }) => {
    const isFetching = useSelector(getUsersIsFetching);
    const [userApplicationToDelete, setUserApplicationToDelete] = useState<number | null>(null);

    console.log(applications);

    const columns = [
        {
            key: 1,
            heading: 'Challenge Name',
            getValue: (row: Submission) => `${row.challengeName}`,
            getSort: (a: Submission, b: Submission) => {
                if (!!a.challengeName && !!b.challengeName)
                    return a.challengeName.localeCompare(b.challengeName);
                else return 0;
            },
            searchable: true,
        },
        {
            key: 2,
            heading: 'Created on',
            getValue: (row: Submission) => {
                if (!!row.createdOn) return `${dayjs(row.createdOn).format('DD/MM/YYYY')}`;
                else return '-';
            },
            searchable: true,
        },
        {
            key: 3,
            heading: 'Percent complete',
            getValue: ({ percentComplete }: Submission) => {
                return `${Math.round(percentComplete * 100)}%`;
            },
        },
        {
            key: 4,
            heading: '',
            getValue: (row: Submission) => (
                <ButtonRow alignment="top">
                    <LinkButton color="green" icon="search" href={`/users/application/${row.id}`}>
                        View Details
                    </LinkButton>
                    <ActionButton
                        color="red"
                        icon="times"
                        onClick={() => setUserApplicationToDelete(row.id)}
                    >
                        Remove
                    </ActionButton>
                </ButtonRow>
            ),
        },
    ];
    return (
        <>
            <Table
                columns={columns}
                rows={Object.values(applications)}
                isLoading={isFetching}
                noDataMessage="No applications found"
            />
            {!!userApplicationToDelete && (
                <DeleteUserApplicationModal
                    application={convertArrToObj(applications)[userApplicationToDelete]}
                    setUserApplicationToDelete={setUserApplicationToDelete}
                />
            )}
        </>
    );
};

interface ApplicationTableProps {
    applications: Submission[];
}

export default UsersTable;
